import React from "react";
import ProductCard from "@components/card/ProductCard";
// @ts-ignore
import { faker } from "@faker-js/faker";
import styled from "@emotion/styled";
import { SwiperSlide } from "swiper/react";
import { useTheme } from "@emotion/react";
import SwiperContainer from "@components/swiper/SwiperContainer";

const ProductSwiperItem = styled(SwiperSlide)({
  display: "flex",
  flexGrow: 1,
  minWidth: "160px",
  maxWidth: "160px",
});

type Props = {
  productList: any[];
};
const ProductListSwiper = ({ productList }: Props) => {
  const lang = window.localStorage.getItem("language");

  return (
    <SwiperContainer space={0}>
      {productList?.map((item) => (
        <ProductSwiperItem key={item.product_id}>
          <ProductCard
            id={item.product_id}
            brand={item[`brand_name_${lang}`] || item.brand_name_ko}
            name={item[`product_name_${lang}`] || item.product_name_ko}
            src={item.thumbnail_url}
            price={item.price}
            likeCount={item.like_total}
            chatCount={item.qna_total}
            haveLike={false}
            soldout={item.is_sold_out === 0 ? false : true}
            isLiked={item.is_liked === 0 ? false : true}
            condition={item.product_condition}
            isActive={item.is_active ? false : true}
          />
        </ProductSwiperItem>
      ))}
    </SwiperContainer>
  );
};

export default ProductListSwiper;
